<div [ngSwitch]="activeView">
  <ng-template [ngSwitchCase]="'DESKTOP'">
    <div>
      <ion-grid class="ion-no-padding">
        <ion-row>
          <ion-col style="padding: 0; align-items: center; display: flex">
            <div>
              <ion-text
                style="font-style: italic; font-size: 0.8571rem"
                color="medium"
                >{{ options?.orderInfo }}</ion-text
              >
            </div>
          </ion-col>
          <ion-col size="auto" float-right>
            <!--            <ion-button color="dgrey" fill="outline" float-end class="table-action-btns" tooltipPosition="bottom" pTooltip="Export" tooltipStyleClass="tooltip-bg-white"  ><ion-icon [src]="'./assets/export.svg'" color="dgrey" size="small"></ion-icon></ion-button>-->
            <ion-button
              color="dgrey"
              fill="outline"
              float-end
              class="table-action-btns"
              tooltipPosition="bottom"
              pTooltip="Add column"
              tooltipStyleClass="tooltip-bg-white"
              (click)="manageColumns($event)"
              ><ion-icon
                [src]="'./assets/add-column.svg'"
                color="dgrey"
                size="small"
              ></ion-icon
            ></ion-button>
            <ion-button
              color="dgrey"
              fill="outline"
              float-end
              class="table-action-btns"
              tooltipPosition="bottom"
              pTooltip="Refresh"
              tooltipStyleClass="tooltip-bg-white"
              (click)="refreshOrders()"
              ><ion-icon
                name="refresh"
                mode="ios"
                color="dgrey"
                size="small"
              ></ion-icon
            ></ion-button>
            <ion-button
              color="dgrey"
              fill="outline"
              float-end
              class="table-action-btns"
              tooltipPosition="bottom"
              pTooltip="You can bulk assign executives from here."
              (click)="selectPickupExecutive()"
              tooltipStyleClass="tooltip-bg-white"
              *ngIf="
                selectedOrders.length > 1 && showActionButton('assignExecutive')
              "
              ><ion-icon name="person-add" color="dgrey" size="small"></ion-icon
            ></ion-button>
            <rcyl-make-payment-button
              *ngIf="
                showActionButton('makePayment') && selectedOrders.length > 1
              "
              [selectedOrders]="selectedOrders"
              (paymentStatus)="makePayment($event)"
            ></rcyl-make-payment-button>
          </ion-col>
        </ion-row>
      </ion-grid>
      <p-table
        #dt
        [value]="orders"
        [paginator]="
          options?.page?.totalCount > options?.page?.size ? true : false
        "
        [lazy]="true"
        [rows]="options.page.size"
        [(first)]="currentPage"
        [totalRecords]="options.page.totalCount"
        (onLazyLoad)="setPage($event)"
        sortMode="multiple"
        (onSort)="onSort($event)"
        [scrollable]="orders?.length > 0 ? true : false"
        [style]="{ width: '100%' }"
        [selectionMode]="'multiple'"
        [tableStyleClass]="
          orders?.length > 0 ? 'ui-table-responsive' : 'normal-table'
        "
        [tableStyle]="{ 'background-color': '#fff' }"
        (onRowSelect)="onRowClick($event)"
        (onRowUnselect)="onRowUnselect($event)"
        [loading]="loadingIndicator"
        [(selection)]="selectedOrders"
      >
        <ng-template pTemplate="emptymessage" let-columns>
          <tr padding="" *ngIf="!loadingIndicator">
            <td text-center="" colspan="100%">No Orders found</td>
          </tr>
        </ng-template>
        <ng-template pTemplate="colgroup">
          <colgroup>
            <col *ngIf="options.selectable" style="width: 100px" />
            <col
              *ngFor="let col of options.columns"
              [hidden]="!col.display"
              [ngStyle]="{ width: col.width || '100px' }"
            />
            <col
              *ngIf="showActionButton('showPaymentStatusCol')"
              style="width: 150px"
            />
            <col
              *ngIf="
                showActionButton('assignExecutive') ||
                showActionButton('makePayment')
              "
              style="width: 150px"
            />
            <col
              *ngIf="options.actions.length > 0 && showActionButton('view')"
              style="width: 50px"
              class="action-col"
            />
          </colgroup>
        </ng-template>
        <ng-template pTemplate="header" [ngIf]="orders?.length > 0">
          <tr>
            <th *ngIf="options.selectable"></th>
            <th *ngFor="let thCol of options.columns" [hidden]="!thCol.display">
              {{ thCol?.label }}
              <p-sortIcon
                *ngIf="thCol?.sort"
                pSortableColumn="{{ thCol?.sort }}"
                [field]="thCol.sort"
              ></p-sortIcon>
            </th>
            <th *ngIf="showActionButton('showPaymentStatusCol')">
              Payment Status
            </th>
            <th
              *ngIf="
                showActionButton('assignExecutive') ||
                showActionButton('makePayment')
              "
              style="width: 150px"
            >
              Actions
            </th>
            <th
              *ngIf="options.actions.length > 0 && showActionButton('view')"
              style="width: 50px"
            ></th>
          </tr>
          <tr>
            <th class="filter-col" *ngIf="options.selectable"></th>
            <th
              class="filter-col"
              *ngFor="let thCol of options.columns"
              [hidden]="!thCol.display"
            >
              <rcyl-data-filter-inputs
                *ngIf="thCol.filterOptions"
                [filterOptions]="options.filters"
                [inputData]="thCol.filterOptions"
                (applyFilters)="applyFilter($event)"
              ></rcyl-data-filter-inputs>
            </th>
            <th
              class="filter-col"
              *ngIf="showActionButton('showPaymentStatusCol')"
            ></th>
            <th
              class="filter-col"
              *ngIf="
                showActionButton('assignExecutive') ||
                showActionButton('makePayment')
              "
            ></th>
            <th
              class="filter-col"
              *ngIf="options.actions.length > 0 && showActionButton('view')"
            ></th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-order>
          <tr>
            <td *ngIf="options.selectable">
              <p-tableCheckbox [value]="order"></p-tableCheckbox>
            </td>
            <td
              *ngFor="let tdCol of options.columns"
              [hidden]="!tdCol.display"
              [pSelectableRow]="order"
            >
              <!--dynamic data START-->
              <rcyl-order-list-data
                [order]="order"
                [column]="tdCol"
                (idClicked)="idClicked($event)"
              ></rcyl-order-list-data>
              <!--dynamic data END-->
            </td>
            <td *ngIf="showActionButton('showPaymentStatusCol')">
              <div [ngSwitch]="order.paymentStatus">
                <ng-template [ngSwitchCase]="'INVOICE_PENDING'">
                  <div class="status-display">
                    <div class="status-dot invoice_pending"></div>
                    <div>
                      <ion-text color="medium" text-regular=""
                        >Invoice Pending</ion-text
                      >
                    </div>
                  </div>
                </ng-template>
                <ng-template [ngSwitchCase]="'INVOICE_VERIFICATION_PENDING'">
                  <rcyl-verify-invoice-button
                    [formattedId]="order.formattedId"
                    [id]="order.id"
                    (verifiedStatus)="verifyInvoice($event)"
                  ></rcyl-verify-invoice-button>
                </ng-template>
                <ng-template [ngSwitchCase]="'INVOICE_REJECTED'">
                  <div class="status-display">
                    <div class="status-dot invoice_rejected"></div>
                    <div>
                      <ion-text color="medium" text-regular=""
                        >Invoice Rejected</ion-text
                      >
                    </div>
                  </div>
                </ng-template>
              </div>
            </td>
            <td
              *ngIf="
                showActionButton('assignExecutive') ||
                showActionButton('makePayment')
              "
              style="width: 150px"
            >
              <div d-flex="" class="ion-align-items-center">
                <ion-button
                  *ngIf="
                    showActionButton('assignExecutive') &&
                    selectedOrders.length < 2 &&
                    order.orderType === 'PICKUP'
                  "
                  (click)="selectPickupExecutive(order)"
                  color="primary"
                >
                  Assign Executive
                </ion-button>
                <rcyl-make-payment-button
                  *ngIf="
                    showActionButton('makePayment') && selectedOrders.length < 2
                  "
                  [selectOrder]="order?.id"
                  [order]="order"
                  [tradeType]="order?.tradeType"
                  (paymentStatus)="makePayment($event)"
                ></rcyl-make-payment-button>
              </div>
            </td>
            <td
              *ngIf="options.actions.length > 0 && showActionButton('view')"
              style="width: 50px"
              class="action-col"
            >
              <div d-flex="" class="ion-align-items-center">
                <ion-button
                  *ngIf="showActionButton('proformaDownload')"
                  tooltipPosition="bottom"
                  pTooltip="Download Proforma Invoice"
                  (click)="downloadProforma(order)"
                  class="proforma-downloaf-btn view-btn"
                >
                  <ion-icon class="ion-margin-start" name="download"></ion-icon>
                </ion-button>
                <ion-button
                  [hidden]="
                    selectedOrders.length > 2 &&
                    orderConfig.channel === 'STARGAZE' &&
                    showActionButton('assignExecutive')
                  "
                  (click)="viewDetails(order, null)"
                  class="view-btn"
                >
                  <ion-icon class="ion-margin-start" name="eye"></ion-icon>
                </ion-button>
              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </ng-template>

  <ng-template [ngSwitchCase]="'MOBILE'">
    <div *ngIf="options.channelName !== 'Marketplace'">
      <order-card
        [order]="order"
        *ngFor="let order of orders"
        (onOrderClicked)="viewDetails($event, null)"
      ></order-card>
    </div>
    <div *ngIf="options.channelName == 'Marketplace'">
      <market-order-card
        [order]="order"
        *ngFor="let order of orders"
        (onOrderClicked)="viewDetails($event, null)"
      ></market-order-card>
    </div>
    <ion-grid
      d-flex
      style="height: 95%"
      *ngIf="loadingIndicator && orders?.length <= 0"
    >
      <ion-row style="height: 95%; width: 100%">
        <ion-col text-center d-flex align-self-center justify-content-center>
          <div><ion-spinner name="crescent"></ion-spinner></div>
          <div d-flex align-self-center>&nbsp; Fetching Orders...</div>
        </ion-col>
      </ion-row>
    </ion-grid>
    <ion-infinite-scroll
      threshold="100px"
      [disabled]="orders?.length >= options.page.totalCount"
      (ionInfinite)="loadMore($event)"
    >
      <ion-infinite-scroll-content loadingText="Loading more orders...">
      </ion-infinite-scroll-content>
    </ion-infinite-scroll>
  </ng-template>
</div>
